import React, { useEffect, useState } from 'react'
import { Flex, Form, Input, Space, Table } from 'antd';
import Main from '../../../cpn/Main';
import GoodsEdit from './GoodsEdit';    
import GoodsAdd from './GoodsAdd';
import { useChanpinTypeListQuery } from '../../../store/DianShangYeWuApi';
import Icon from '../../../cpn/Icon';
import classes from '../../system.module.css';
function GoodsList() {
    const [list, setList] = useState();    
    const qy_id = JSON.parse(localStorage.getItem('jtg-caiwu_qy_id'))
    const qy_name = JSON.parse(localStorage.getItem('jtg-caiwu_qy_name'))   
    const yh_id = JSON.parse(localStorage.getItem('jtg-caiwu_yh_id'))
    const yh_name = JSON.parse(localStorage.getItem('jtg-caiwu_yh_name'))
    const [query,setQuery] = useState({
        dscp_qy_id:qy_id,
        dscp_name:'',
    })
    const {data, isSuccess} = useChanpinTypeListQuery(query,{refetchOnMountOrArgChange:true});
    useEffect(() => {
        if (isSuccess) {
            // console.log(data);
            if(data.Status==='success'){                
                const newArr = data.Result.map(item => {
                    const {dscp_id:key,dscp_name,dscp_uname,dscp_ctime,dscp_update_time,dscp_update_uname} = item;                 
                    return item = {key,dscp_name,dscp_uname,dscp_ctime,dscp_update_time,dscp_update_uname}
                }) 
                const sortArr = newArr.sort( (a, b) => {      
                    let aTimeString = a.dscp_ctime;
                    let bTimeString = b.dscp_ctime;
                    let aTime = new Date(aTimeString).getTime();
                    let bTime = new Date(bTimeString).getTime();
                    return bTime - aTime;     
                    },)
                setList(sortArr)
            }else{
                setList('')
            }
            
        }
    }, [data, isSuccess])
    const columns = [
        {
            key: 'dscp_name',
            title: '产品名称',            
            dataIndex: 'dscp_name',
            render: (_, record) => {
                return <GoodsEdit
                            dscp_id={record.key} 
                            dscp_name={record.dscp_name} 
                            qy_id={qy_id}
                            qy_name={qy_name}
                            yh_id={yh_id}
                            yh_name={yh_name}
                        />
            }
        },              
        {
            key: 'dscp_ctime',
            title: '新增记录',            
            dataIndex: 'dscp_ctime',
            render:(text,record) => {
                return<>{text} {record.dscp_uname}</>
            }
        },   
        {
            key: 'dscp_update_time',
            title: '修改记录',            
            dataIndex: 'dscp_update_time',
            render:(text,record) => {
                return<>{text} {record.dscp_update_uname}</>
            }
        },   
        {
            key: 'key',
            title: '编号',
            dataIndex: 'key',
        },
    ]   
    const [form] = Form.useForm();
    return (
        <Main selectedKeys={['/GoodsList']}>                       
             <Flex align='center' justify='space-between'>
               
                <Form
                    layout='inline'
                    form={form}
                    onFinish={(values) => {   
                        setQuery({...query,dscp_name:values.dscp_name})
                    }}
                    initialValues={{
                        dscp_name:'',
                    }}
                >
                    <Form.Item name='dscp_name'>
                        <Input placeholder='请输入产品名称' />
                    </Form.Item>                    
                    <Form.Item>
                        <Space align='center' size='middle'>
                            <Icon type='search' onClick={() => {form.submit()}}/>
                            <Icon type='reset' onClick={() => {
                                form.resetFields();
                                setQuery({...query,dscp_name:''})
                            }}></Icon>
                           
                        </Space>
                    </Form.Item>
                </Form>
                <GoodsAdd 
                    qy_id={qy_id}
                    qy_name={qy_name}
                    yh_id={yh_id}
                    yh_name={yh_name}
                />
            </Flex>
            <Table 
                columns={columns} 
                dataSource={list} 
                pagination={{
                    showSizeChanger:true,
                    defaultPageSize:'50',
                    showTotal:(total) => `共${total}条`,
                }} 
                className={classes.customTable}
                style={{marginTop:"10px"}}
                bordered
                size='small'
                rowKey="key"
            />
        </Main>
    )
}

export default GoodsList